var mentions_default = {
  "mentionPalette": "LlSqm",
  "mention": "_9TqMQ",
  "mentionViewer": "RYoyC",
  "mentionSuggestionsEntry": "gN-yb",
  "mentionSuggestionsEntryFocused": "GPvHv",
  "mentionSuggestionsEntryText": "oi1KM",
  "mentionSuggestionsEntryAvatar": "Vbi3M",
  "mentionSuggestions": "dK-K0",
  "cursorDefault": "PnCvM",
  "cursorPointer": "mgucu"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
